jQuery(document).ready(function() {
  jQuery(window).scroll(function() {

    if (jQuery(window).width() < 768) {
      // Якщо ширина екрану менше 768px, не виконуємо паралакс
      return;
    }
    
    var scrollTop = jQuery(window).scrollTop();
    
    // Adjust these values to change the speed of the parallax effect
    var speed1 = 0.4;
    var speed2 = 0.3;
    var speed3 = 0.6;
    
    // Adjust these values to set the delay before the blocks start moving
    var delay1 = 2000;
    var delay2 = 2200;
    var delay3 = 1800;

    var translateY1 = (scrollTop - delay1) * speed1;
      var translateY2 = (scrollTop - delay2) * speed2;
      var translateY3 = (scrollTop - delay3) * speed3;

      if (scrollTop > delay1) {
        jQuery('.about_us__img_1').css('transform', 'translateY(' + -translateY1 + 'px)');
      }
      if (scrollTop > delay2) {
        jQuery('.about_us__img_2').css('transform', 'translateY(' + -translateY2 + 'px)');
      }
      if (scrollTop > delay3) {
        jQuery('.about_us__img_3').css('transform', 'translateY(' + -translateY3 + 'px)');
      }
  });
});
